<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AZJEsU/images/Cover.jpg?1703000716494" alt="This image is the cover for the book Rowntrees"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rowntrees
      </h1>
      <p class="bookDescription body article font2">
        <p>The Rowntree family, especially Henry and the younger Joseph Rowntree are, along with the Fry’s, Cadbury’s, Mars and Terry’s, synonymous with the birth and growth of the chocolate industry in Britain. Between them, they were the chocolate industry in Britain.  This book charts the fascinating story behind the birth and development of the chocolate empire that was Rowntrees. Background information to this astonishing business comes by way of chapters on the early history of the Rowntrees, contemporary York, the relationship between Quakers and chocolate, and the Tuke family – without whom there would have been no Rowntrees, and no Kit Kats.  Henry, it is usually forgotten, was the founder of Rowntree’s – he made the momentous decision to sign the deal with the Tukes and we join him in those very early days of the fledgling company and watch how he helped it through some very dark, and sometimes humorous, times in what was then a very shambolic set up – cash strapped and making it up as the company lurched from crisis to crisis. Joseph, his elder brother, it was, who became the driving force to eventual global success, mixing his hectic business life with acts of compassion and a benevolent management model, all of which paved the way for decent wages, pensions, insurance and mutual respect in the workplace. Charity work extended beyond the factories to lift workers and others out of the slums of York to a life in a healthy model village, to provide a good social life, an extensive park, swimming pool and education for children and adults. More context is given with chapters on Joseph’s relentless industrial espionage, the advancements in chocolate production and 20th century rivals in the domestic and export markets, and mergers and acquisitions.  Rowntree’s role in the two world wars is also covered along with the struggle Joseph Rowntree had accepting the importance of advertising. Altogether this book gives two fascinating biographies of two exceptional and driven brothers who came together to form one of our greatest companies - producing some of our best loved confectionery products.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Chrystal
      </h2>
      
      <p class="authorDescription body article">Paul Chrystal is the author of some seventy books published over the last decade, including recent publications such as Wars and Battles of the Roman Republic, Roman Military Disasters and Women and War in Ancient Greece and Rome. He is a regular contributor to history magazines, local and national newspapers and has appeared on BBC Radio 4, BBC World Service and on BBC local radio throughout Yorkshire and in Teesside and Manchester. He writes extensively for several Pen & Sword military history series including ‘Cold War 1945–1991’, ‘A History of Terror’ and ‘Military Legacy’ (of British cities).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d2ef318